import { Box, MenuItem } from "@mui/material";
import Select from "../../select/select";
import Typography from "../../typography/typography";
import { OperatorSelectorProps } from "react-querybuilder";
import formatText from "../../../utils/format-text";

const OperatorSelect = (props: OperatorSelectorProps) => {
  const { handleOnChange, options, ...rest } = props;


  return (
    <Box width='100%'>
      <Select
        fullWidth
        {...rest}
        onChange={(e: any) => handleOnChange(e.target.value)}
        className="select-drps"
        variant="outlined"
        renderValue= {(selected: string) => {
          const dValue = options?.find(o => o.name==selected)?.label
          return dValue ? formatText(dValue) : selected
        }}
      >
        {options?.filter(o => Boolean(o.label?.trim()))?.map((op: any) => (
          <MenuItem key={op.name} value={op.name}>
            <Typography type="s4" color="theme.secondary.1000">
              {formatText(op.label)}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export { OperatorSelect };
export default OperatorSelect;
